import React from 'react'

import { useWindowSize } from '@hooks/useWindowSize'
import { WriterSalesAnalyticsDetailReportEnum } from '@interfaces/WriterSalesAnalyticsDetailReportEnum'
import NoData from '@components/NoData'
import { Tabs } from '@components/TabsV2'
import { TabModeEnum } from '@components/Tabs/interface'
import { SaleAnalyticsChart } from '../SaleAnalyticsChart'
import { OverviewTabsProps } from './interface'
import { OverviewTableTemplate } from '../OverviewTableTemplate'
import {
  columnsDonation,
  columnsLike,
  columnsSales,
  columnsShelfAdded,
  columnsView,
} from './columns'

export function OverviewTabs({
  data,
  isLoading,
  sortParams,
  queryParams,
  handleTabChange,
  handleSortChange,
}: OverviewTabsProps) {
  const { isMobile, isTablet } = useWindowSize()
  return (
    <div className='mt-[60px]'>
      <Tabs
        tabs={
          queryParams.bookId
            ? [
                {
                  key: WriterSalesAnalyticsDetailReportEnum.SALES_BY_CHAPTER,
                  title: 'ยอดขายรายตอน',
                  component: (
                    <>
                      {data.graphData.length === 0 &&
                      data.tableData.length === 0 ? (
                        <NoData />
                      ) : (
                        <>
                          <SaleAnalyticsChart
                            data={data.graphData}
                            graphType={data.graphType}
                            tabId={
                              WriterSalesAnalyticsDetailReportEnum.SALES_BY_CHAPTER
                            }
                            style={{
                              height: isMobile ? 260 : 300,
                              width: isMobile ? 340 : isTablet ? 750 : 1166,
                            }}
                          />
                          <OverviewTableTemplate
                            title='ยอดขายรายตอน'
                            data={data.tableData}
                            columns={columnsSales({
                              sortParams,
                              bookId: queryParams.bookId,
                              isMobile,
                              handleSortChange,
                            })}
                          />
                        </>
                      )}
                    </>
                  ),
                },
                {
                  key: WriterSalesAnalyticsDetailReportEnum.SALES_BY_BOOK,
                  title: 'ยอดขายรวมเล่ม',
                  component: (
                    <>
                      {data.graphData.length === 0 &&
                      data.tableData.length === 0 ? (
                        <NoData />
                      ) : (
                        <>
                          <SaleAnalyticsChart
                            data={data.graphData}
                            graphType={data.graphType}
                            tabId={
                              WriterSalesAnalyticsDetailReportEnum.SALES_BY_BOOK
                            }
                            style={{
                              height: isMobile ? 260 : 300,
                              width: isMobile ? 340 : isTablet ? 750 : 1166,
                            }}
                          />
                          <OverviewTableTemplate
                            title='ยอดขายรวมเล่ม'
                            data={data.tableData}
                            columns={columnsSales({
                              sortParams,
                              bookId: queryParams.bookId,
                              isMobile,
                              handleSortChange,
                            })}
                          />
                        </>
                      )}
                    </>
                  ),
                },
                {
                  key: WriterSalesAnalyticsDetailReportEnum.DONATION,
                  title: 'การสนับสนุน',
                  component: (
                    <>
                      {data.graphData.length === 0 &&
                      data.tableData.length === 0 ? (
                        <NoData />
                      ) : (
                        <>
                          <SaleAnalyticsChart
                            data={data.graphData}
                            graphType={data.graphType}
                            style={{
                              height: isMobile ? 260 : 300,
                              width: isMobile ? 340 : isTablet ? 750 : 1166,
                            }}
                          />
                          <OverviewTableTemplate
                            title='การสนับสนุน'
                            data={data.tableData}
                            columns={columnsDonation({
                              sortParams,
                              bookId: queryParams.bookId,
                              isMobile,
                              handleSortChange,
                            })}
                          />
                        </>
                      )}
                    </>
                  ),
                },
                {
                  key: WriterSalesAnalyticsDetailReportEnum.VIEW,
                  title: 'ยอดวิว',
                  component: (
                    <>
                      {data.graphData.length === 0 &&
                      data.tableData.length === 0 ? (
                        <NoData />
                      ) : (
                        <>
                          <SaleAnalyticsChart
                            data={data.graphData}
                            graphType={data.graphType}
                            style={{
                              height: isMobile ? 260 : 300,
                              width: isMobile ? 340 : isTablet ? 750 : 1166,
                            }}
                          />
                          <OverviewTableTemplate
                            title='ยอดวิว'
                            data={data.tableData}
                            columns={columnsView({
                              sortParams,
                              isMobile,
                              bookId: queryParams.bookId,
                              handleSortChange,
                            })}
                          />
                        </>
                      )}
                    </>
                  ),
                },
              ]
            : [
                {
                  key: WriterSalesAnalyticsDetailReportEnum.SALES,
                  title: 'ยอดขาย',
                  component: (
                    <>
                      {data.graphData.length === 0 &&
                      data.tableData.length === 0 ? (
                        <NoData />
                      ) : (
                        <>
                          <SaleAnalyticsChart
                            data={data.graphData}
                            graphType={data.graphType}
                            tabId={WriterSalesAnalyticsDetailReportEnum.SALES}
                            style={{
                              height: isMobile ? 260 : 300,
                              width: isMobile ? 340 : isTablet ? 750 : 1166,
                            }}
                          />
                          <OverviewTableTemplate
                            title='ยอดขาย'
                            data={data.tableData}
                            columns={columnsSales({
                              sortParams,
                              isMobile,
                              handleSortChange,
                            })}
                          />
                        </>
                      )}
                    </>
                  ),
                },
                {
                  key: WriterSalesAnalyticsDetailReportEnum.DONATION,
                  title: 'การสนับสนุน',
                  component: (
                    <>
                      {data.graphData.length === 0 &&
                      data.tableData.length === 0 ? (
                        <NoData />
                      ) : (
                        <>
                          <SaleAnalyticsChart
                            data={data.graphData}
                            graphType={data.graphType}
                            style={{
                              height: isMobile ? 260 : 300,
                              width: isMobile ? 340 : isTablet ? 750 : 1166,
                            }}
                          />
                          <OverviewTableTemplate
                            title='การสนับสนุน'
                            data={data.tableData}
                            columns={columnsDonation({
                              sortParams,
                              isMobile,
                              handleSortChange,
                            })}
                          />
                        </>
                      )}
                    </>
                  ),
                },
                {
                  key: WriterSalesAnalyticsDetailReportEnum.VIEW,
                  title: 'ยอดวิว',
                  component: (
                    <>
                      {data.graphData.length === 0 &&
                      data.tableData.length === 0 ? (
                        <NoData />
                      ) : (
                        <>
                          <SaleAnalyticsChart
                            data={data.graphData}
                            graphType={data.graphType}
                            style={{
                              height: isMobile ? 260 : 300,
                              width: isMobile ? 340 : isTablet ? 750 : 1166,
                            }}
                          />
                          <OverviewTableTemplate
                            title='ยอดวิว'
                            data={data.tableData}
                            columns={columnsView({
                              sortParams,
                              isMobile,
                              handleSortChange,
                            })}
                          />
                        </>
                      )}
                    </>
                  ),
                },
                {
                  key: WriterSalesAnalyticsDetailReportEnum.LIKE,
                  title: 'กำลังใจ',
                  component: (
                    <>
                      {data.graphData.length === 0 &&
                      data.tableData.length === 0 ? (
                        <NoData />
                      ) : (
                        <>
                          <SaleAnalyticsChart
                            data={data.graphData}
                            graphType={data.graphType}
                            style={{
                              height: isMobile ? 260 : 300,
                              width: isMobile ? 340 : isTablet ? 750 : 1166,
                            }}
                          />
                          <OverviewTableTemplate
                            title='กำลังใจ'
                            data={data.tableData}
                            columns={columnsLike({
                              sortParams,
                              isMobile,
                              handleSortChange,
                            })}
                          />
                        </>
                      )}
                    </>
                  ),
                },
                {
                  key: WriterSalesAnalyticsDetailReportEnum.SHELF_ADDED,
                  title: 'การเพิ่มเข้าชั้น',
                  component: (
                    <>
                      {data.graphData.length === 0 &&
                      data.tableData.length === 0 ? (
                        <NoData />
                      ) : (
                        <>
                          <SaleAnalyticsChart
                            data={data.graphData}
                            graphType={data.graphType}
                            style={{
                              height: isMobile ? 260 : 300,
                              width: isMobile ? 340 : isTablet ? 750 : 1166,
                            }}
                          />
                          <OverviewTableTemplate
                            title='การเพิ่มเข้าชั้น'
                            data={data.tableData}
                            columns={columnsShelfAdded({
                              sortParams,
                              isMobile,
                              handleSortChange,
                            })}
                          />
                        </>
                      )}
                    </>
                  ),
                },
              ]
        }
        initialTab='reading'
        mode={TabModeEnum.LINE}
        handleTabChange={handleTabChange}
        isLoading={isLoading}
        queryTabKey='reportType'
      />
    </div>
  )
}
